export const blockIconsAudioandvideoSubscriptionsNew = (
	<span className='material-symbols-outlined'>subscriptions</span>
);
